exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yd-logo {\n  cursor: pointer;\n  left: 0;\n  top: 0;\n  height: 56px;\n  width: 129px;\n  z-index: 998;\n  background-color: #22c655;\n}\n.logo {\n  height: 56px;\n  width: 129px;\n}", ""]);

// exports
